import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void,
    onCancel: () => void
}

const MarkResultsReviewedModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Mark Results Reviewed
            </Modal.Header>
            <Modal.Body>
                {/* <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to mark the lab results reviewed for donor <strong>{props.fullName}</strong>...
                </div> */}

                <Alert bsStyle='warning'>Confirm that you want to mark the lab results reviewed for donor <strong>{props.fullName}</strong></Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MarkResultsReviewedModal;